import { render, staticRenderFns } from "./SpaceAll.vue?vue&type=template&id=0247d481"
import script from "./SpaceAll.vue?vue&type=script&lang=js"
export * from "./SpaceAll.vue?vue&type=script&lang=js"
import style0 from "./SpaceAll.vue?vue&type=style&index=0&id=0247d481&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports